import React from 'react';
import { List, X } from 'lucide-react';

const PDFPageList = ({
  showPageList, setShowPageList,
  numPages, pageNumber, goToPage, cachedPages
}) => {
  if (!showPageList) return null;

  return (
    <div className="absolute left-0 top-0 bottom-0 w-48 bg-slate-800/95 border-r border-slate-700 z-30 overflow-hidden flex flex-col">
      <div className="p-3 border-b border-slate-700 flex items-center justify-between">
        <h3 className="text-white font-medium text-sm flex items-center gap-2">
          <List className="h-4 w-4 text-teal-400" />
          Paginas
        </h3>
        <button 
          onClick={() => setShowPageList(false)}
          className="text-slate-400 hover:text-white"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto p-2 space-y-1">
        {Array.from({ length: numPages }, (_, i) => i + 1).map((page) => (
          <button
            key={page}
            onClick={() => { goToPage(page); }}
            className={`w-full text-left px-3 py-2 rounded transition-colors flex items-center justify-between ${
              page === pageNumber 
                ? 'bg-teal-500/30 text-teal-300 border border-teal-500/50' 
                : 'text-slate-300 hover:bg-slate-700'
            }`}
          >
            <span className="text-sm">Pagina {page}</span>
            {cachedPages.has(page) && (
              <span className="text-xs text-teal-400">⚡</span>
            )}
          </button>
        ))}
      </div>
      <div className="p-2 border-t border-slate-700 text-center">
        <span className="text-xs text-slate-500">
          {cachedPages.size} paginas en cache
        </span>
      </div>
    </div>
  );
};

export default PDFPageList;
